import { apiCallingFailure, apiCallingStart, defaultCalling, getOrg, orgUpdate, setAddress } from "../Reducers/orgReducers";
import { apiRequest } from "../../common/common";

const defaultOrgApiCall = () => async dispatch => {
    dispatch(defaultCalling());
}

const getOrganization = org => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('get', `/organization/${org.organizationId}`);
        if (response?.data) {
            dispatch(getOrg(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
};

const updateOrganization = organization => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('put', `/organization/${organization.organizationId}`, {
            org_email: organization.orgEmail,
            org_phone_number: organization.phoneNumber,
            org_website: organization.website,
            department: organization.department,
            title: organization.title,
            user_id: organization.userId,
            org_name: organization.name
        });
        if (response?.data) {
            dispatch(orgUpdate(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.status || error.message));
    }
};

const createAddress = address => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('post', `/address`, {
            address_line_1: address?.address1,
            address_line_2: address?.address2,
            city: address?.city,
            state: address?.state,
            country: address?.country,
            user_id: address?.userId,
            organization_id: address?.organizationId,
            pincode: address?.zipCode
        });
        if (response?.data) {
            dispatch(setAddress(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.status || error.message));
    }
};

const updateAddress = address => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('put', `/address/${address?.addressId}`, {
            address_line_1: address?.address1,
            address_line_2: address?.address2,
            city: address?.city,
            state: address?.state,
            country: address?.country,
            user_id: address?.userId,
            organization_id: address?.organizationId,
            pincode: address?.zipCode
        });
        if (response?.data) {
            dispatch(setAddress(response.data));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.status || error.message));
    }
};

const getAddress = address => async dispatch => {
    dispatch(apiCallingStart());
    try {
        const response = await apiRequest('get', `/address?userId=${address.userId}&organizationId=${address.organizationId}`);
        if (response?.data) {
            dispatch(setAddress({
                data: response?.data?.data[0]
            }));
        }
    } catch (error) {
        dispatch(apiCallingFailure(error?.response?.data.error || error.message));
    }
};

export {
    defaultOrgApiCall,
    getOrganization,
    updateOrganization,
    createAddress,
    updateAddress,
    getAddress
}